<div *ngIf="nativeDesktop" class="auth__login__panel__close" [ngClass]="{ disabled: disabled }">
  <button
    class="bfx-icon-button-md bfx-icon-button-secondary-subtle-unsized hide-focus"
    [ngClass]="{ btn: !disabled, 'btn-default': !disabled }"
    (click)="closeDialog()"
    title="Close this window"
  >
    <i class="icon-close"></i>
  </button>
</div>
